import './App.css';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import header from "./component/header";
import login from "./component/Login";

function App() {
  if (process.browser) {
    const authToken = localStorage.getItem("token");

    const { pathname } = window.location;

    if (!authToken && pathname !== "/") {
      window.history.pushState(null, null, "/");
    } else if (authToken && (pathname === "/dashboard" || pathname === "/")) {
      window.history.pushState(null, null, "/dashboard");
    }
  }
  return (
    <div className="App">
      <Router>
        <Switch>
          <Route path="/" exact component={login} />
          <Route path="/dashboard" exact component={header} />
        </Switch>
      </Router>
    </div>
  );
}


export default App;
